import React, { useEffect, useState, useContext } from 'react';
import { Form, Input, DatePicker, Button, Table, Checkbox, Tooltip, Modal, Alert, message } from 'antd';
import apis from './apis';
import WangeditorForAcore from '@/components/wangeditor-for-acore';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import './index.less';
import moment from 'moment';
import utils from '@/common/utils';

const MaterialSettings = (props) => {
  // const detailContext = useContext(ContextProviderMenus);
  const strategyId = utils.getQuery('jobId');
  const activityId = utils.getQuery('activityId');
  const endTime = utils.getQuery('endTime');
  const { disabled = false, onTouchSuccess = () => {}, onSelectType = () => {} } = props;
  const [typeModal, setTypeModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState('');
  const [secondModal, setSecondModal] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      enablePicTransparent: 1,
      enablePicWhite: 1,
      enableContentSell: 1,
      enableSortTitle: 1,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (activityId && disabled) {
      apis.getActivityData(activityId).then((res) => {
        if (res.ret === '0') {
          setDetail(res.data.description);
          form.setFieldsValue({ ...res.data, ...{ endTime: moment(res.data.endTimeStr) } });
        } else {
          message.error(res.msg);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityId, disabled]);

  const dataSource = [
    {
      key: 'enablePicTransparent',
      title: '商品透底图',
    },
    {
      key: 'enablePicWhite',
      title: '商品白底图',
    },
    {
      key: 'enableContentSell',
      title: '营销卖点',
    },
    {
      key: 'enableSortTitle',
      title: '营销短标题',
    },
  ];
  const columns = [
    {
      title: (
        <span>
          是否启用<Tooltip></Tooltip>
        </span>
      ),
      dataIndex: 'key',
      width: 200,
      render: (item) => (
        <Form.Item
          name={item}
          valuePropName="checked"
          getValueFromEvent={(e) => {
            if (e.target.checked) {
              return 1;
            } else {
              return 0;
            }
          }}
        >
          <Checkbox disabled={disabled}></Checkbox>
        </Form.Item>
      ),
    },
    {
      title: '字段名称',
      dataIndex: 'title',
    },
  ];
  const onFinish = (e) => {
    if (e.endTime < moment()) {
      form.setFields([
        {
          errors: ['截止时间不能小于当前时间'],
          name: 'endTime',
        },
      ]);
      return message.error('截止时间不能小于当前时间');
    }
    if (e.endTime > moment(+endTime)) {
      form.setFields([
        {
          errors: ['截止时间不能大于活动结束时间'],
          name: 'endTime',
        },
      ]);
      return message.error('截止时间不能大于活动结束时间');
    }
    setLoading(true);
    apis
      .saveActivityData({ ...e, ...{ endTime: moment(e.endTime).format('YYYY-MM-DD HH:mm:ss') }, ...{ activityId } })
      .then((res) => {
        setLoading(false);
        if (res.ret === '0') {
          setTypeModal(true);
          onTouchSuccess();
        } else {
          message.error(res.msg);
        }
      });
  };

  const onSubmit = () => {
    apis.confirmSelection({ activityId, strategyId, noticeScope: 0 }).then((resp) => {
      if (resp.ret === '0') {
        message.success('素材维护触达成功！');
        onSelectType({
          noticeScope: 0,
        });
      } else {
        message.error(resp.msg);
      }
    });
  };

  function disabledDate(current) {
    // Can not select days before today and today
    return (current && current > moment(+endTime).add(1, 'd')) || (current && current < moment().subtract(1, 'd'));
  }

  const nextStep = () => {
    setSecondModal(false);
    onSelectType({
      noticeScope: 1,
    });
  };

  return (
    <div className="material-settings">
      {!disabled && (
        <React.Fragment>
          <Alert
            showIcon
            message={
              <span style={{ color: '#2D64FF' }}>
                设置完成后，将会触达商家/采销维护素材不完善的商品，无需报名。
                <span style={{ color: '#ff4c4c' }}>素材维护触达采销/商家，仅可操作一次</span>
              </span>
            }
            type="info"
          />
          <div className="title-area">
            <div className="title">提报字段设置使用说明</div>
            <div>
              通过提报信息配置，可要求报名者在提报商品/店铺时填写会场搭建需要的基础素材，基础素材代表适用于大部分楼层的通用信息，如商品透底图、名称、卖点等，素材收集完成后，后续可通过智能合图将素材组合成活动图片，用于会场展示。
            </div>
          </div>
        </React.Fragment>
      )}
      <Form wrapperCol={{ span: 12 }} onFinish={onFinish} form={form}>
        <Form.Item
          className="asd"
          label="维护触达标题"
          rules={[{ required: true }]}
          name="title"
          wrapperCol={{ span: 5 }}
        >
          <Input placeholder="请输入" disabled={disabled} maxLength={30} />
        </Form.Item>
        {disabled ? (
          <Form.Item label="维护触达介绍" rules={[{ required: true }]} name="description">
            <div className="editor" dangerouslySetInnerHTML={{ __html: detail }}></div>
          </Form.Item>
        ) : (
          <Form.Item label="维护触达介绍" rules={[{ required: true }]} name="description">
            <WangeditorForAcore
              height={300}
              disabled={disabled}
              placeholder="维护素材要求:描述维护素材的规格要求，如素材类型、图片尺寸大小、文字长短、内容要求等"
            />
          </Form.Item>
        )}
        <Form.Item
          label="截止时间 "
          rules={[{ required: true }]}
          name="endTime"
          tooltip="截止时间需早于或等于已设置的日常活动结束时间"
        >
          <DatePicker showTime disabledDate={disabledDate} disabled={disabled} />
        </Form.Item>
        <Table columns={columns} dataSource={dataSource}></Table>
        {!disabled && (
          <Form.Item wrapperCol={{ span: 12 }} style={{ textAlign: 'center' }}>
            <Button type="primary" htmlType="submit" loading={loading}>
              发起触达
            </Button>
          </Form.Item>
        )}
      </Form>
      <Modal
        visible={typeModal}
        title="请选择商品范围"
        className="shop-cross"
        width={456}
        footer={null}
        onCancel={() => setTypeModal(false)}
      >
        <div>
          <Alert
            message={
              <span style={{ color: 'rgba(254, 176, 14, 1)' }}>请注意：素材维护触达采销/商家，仅可操作一次</span>
            }
            type="warning"
          />
          <div className="msg-area">
            <div
              className="btn-type"
              onClick={() => {
                setSecondModal(true);
                setTypeModal(false);
              }}
            >
              <img src="https://img12.360buyimg.com/imagetools/jfs/t1/190183/29/22280/5972/6239643fE53ff9e7f/3ee7495dab67606f.png" />
              <div className="title">全量商品</div>
              <div className="line"></div>
              <div className="content">策略包含的所有需要完善素材的商品</div>
            </div>
            <div className="btn-type" onClick={() => nextStep()}>
              <img src="https://img12.360buyimg.com/imagetools/jfs/t1/190183/29/22280/5972/6239643fE53ff9e7f/3ee7495dab67606f.png" />
              <div className="title">部分商品</div>
              <div className="line"></div>
              <div className="content">商品范围：进一步通过规则筛选的商品</div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        visible={secondModal}
        title="请确认触达范围"
        footer={null}
        bodyStyle={{ padding: 0 }}
        width={400}
        onCancel={() => setSecondModal(false)}
      >
        <div style={{ padding: '24px' }}>
          全量触达范围为本商品策略包含的所有需完善素材的商品，点击【确定触达】后素材维护触达采销/商家，仅可操作一次！
        </div>
        <div style={{ borderTop: '1px solid #ddd', padding: 16, textAlign: 'right' }}>
          <Button type="primary" style={{ borderRadius: 48 }} onClick={() => onSubmit()}>
            确定
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default MaterialSettings;
